export default __webpack_public_path__ + "static/media/DeleteIcon.143e31f5.svg";